import client from '../../../config/api';
import { getRecord } from '../../../services/db';
import QuestionDTO from '../../../shared/dtos/QuestionDTO';
import { SET_LOADING_STATE } from '../../loading/mutations/mutationTypes';
import {
  LOCAL_SET_QUESTIONS,
  LOCAL_REMOVE_QUESTION,
  LOCAL_UPDATE_QUESTION,
} from '../mutations/mutationTypes';
import { CreateLatestDebouncedAction } from '../../../helpers/CreateLatestDebouncedAction';

export default {
  async SAVE_QUESTIONS(_1, payload) {
    const { taskId, data } = payload;
    return client.post(`/questions/${taskId}`, data);
  },
  async GET_QUESTIONS({ commit }, taskId) {
    const result = await client.get(`/questions/${taskId}`);
    commit(LOCAL_SET_QUESTIONS, result.data);
  },
  async DELETE_QUESTION({ commit }, questionId) {
    if (!questionId) {
      return;
    }

    await client.delete(`/question/${questionId}`);
    commit(LOCAL_REMOVE_QUESTION, questionId);
  },
  async DELETE_QUESTIONS(_1, payload) {
    const taskId = payload;
    return client.delete(`/questions/${taskId}`);
  },
  async CREATE_QUESTION({ commit }, data) {
    const { taskId, question } = data;
    if (!taskId || !question) {
      console.log('Missing requred params for request');
      return;
    }
    const questionDto = new QuestionDTO(question);

    const taskOfQuestion = await getRecord('task', taskId);
    if (taskOfQuestion) {
      const jobOfTask = await getRecord('job', taskOfQuestion.jobId);

      if (jobOfTask && jobOfTask.checkedOut && jobOfTask.checkedOut !== '') {
        questionDto.checkedJobId = jobOfTask._id;
      }
    }

    commit(SET_LOADING_STATE, { value: true }, { root: true });
    const response = await client.post(`/question/${taskId}`, questionDto);

    const newQuestion = new QuestionDTO(response.data);
    commit(LOCAL_UPDATE_QUESTION, newQuestion);
    commit(SET_LOADING_STATE, { value: false }, { root: true });
    return response.data;
  },
  async CREATE_QUESTIONS({ commit }, data) {
    const { taskId, questions } = data;
    if (!taskId || questions.length === 0) {
      console.log('Missing requred params for request');
      return;
    }

    const questionsDTO = questions.map((question) => new QuestionDTO(question));

    commit(SET_LOADING_STATE, { value: true }, { root: true });
    const response = await client.post(`/questions/${taskId}`, questionsDTO);

    commit(SET_LOADING_STATE, { value: false }, { root: true });
    return response.data;
  },
  UPDATE_QUESTION: CreateLatestDebouncedAction({
    keyExtractor: (question) => question._id,
    delay: 500,
    /* eslint-disable no-unused-vars */
    handlerFn: async ({ context, payload }) => {
      const question = new QuestionDTO(payload);
      question.isInspector = payload.isInspector;
      const res = await client.put(`/question/${payload._id}`, question);
      return res.data;
    },
    commitFn: (commit, question) => {
      commit(LOCAL_UPDATE_QUESTION, question);
    },
  }),
};
